export default __webpack_public_path__ + "static/webRotator/svg/4465912dae40b8fbfb07f919de6685ec.svg";